"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = exports.Grid = exports.Col = exports.Row = exports.Flex = exports.Box = exports.FullWidthContainer = exports.Container = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("@styled-system/prop-types"));

var _propTypes2 = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "Layout__StyledContainer",
  componentId: "sc-1le4sa1-0"
})(["", " ", ""], _styledSystem.layout, _styledSystem.space);

var Container = function Container(props) {
  var children = props.children;
  return _react.default.createElement(StyledContainer, (0, _extends2.default)({
    width: "100%",
    maxWidth: ['527px', '927px', '1199px'],
    px: [3],
    mx: ['auto']
  }, props), children);
};

exports.Container = Container;

var FullWidthContainer = function FullWidthContainer(props) {
  var children = props.children;
  return _react.default.createElement(StyledContainer, (0, _extends2.default)({
    width: "100%"
  }, props), children);
};

exports.FullWidthContainer = FullWidthContainer;
var Box = (0, _styledComponents.default)('div').withConfig({
  displayName: "Layout__Box",
  componentId: "sc-1le4sa1-1"
})((0, _styledSystem.compose)(_styledSystem.space, _styledSystem.color, _styledSystem.layout, _styledSystem.flexbox, _styledSystem.position, _styledSystem.border, _styledSystem.background, _styledSystem.opacity, _styledSystem.variant));
exports.Box = Box;
Box.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.default.space), _propTypes.default.color), _propTypes.default.layout), _propTypes.default.flexbox), _propTypes.default.position), _propTypes.default.border), _propTypes.default.opacity), _propTypes.default.variant);
var Flex = (0, _styledComponents.default)(Box).withConfig({
  displayName: "Layout__Flex",
  componentId: "sc-1le4sa1-2"
})({
  display: 'flex'
});
exports.Flex = Flex;
Flex.propTypes = {
  flexWrap: _propTypes2.default.string,
  flexDirection: _propTypes2.default.string,
  alignCols: _propTypes2.default.string,
  justifyContent: _propTypes2.default.string
};

var Row = function Row(props) {
  var children = props.children;
  return _react.default.createElement(Flex, props, children);
};

exports.Row = Row;
Row.defaultProps = {
  flexWrap: 'wrap'
};

var Col = function Col(props) {
  var children = props.children;
  return _react.default.createElement(Box, props, children);
};

exports.Col = Col;
Col.defaultProps = {
  width: '100%',
  flex: '0 1 auto'
};

var Grid = _styledComponents.default.div.withConfig({
  displayName: "Layout__Grid",
  componentId: "sc-1le4sa1-3"
})(["display:grid;", ";", ";"], _styledSystem.grid, _styledSystem.space);

exports.Grid = Grid;

var GridItem = _styledComponents.default.div.withConfig({
  displayName: "Layout__GridItem",
  componentId: "sc-1le4sa1-4"
})(["", " ", ";position:relative;"], _styledSystem.grid, _styledSystem.space);

exports.GridItem = GridItem;
Grid.propTypes = _objectSpread(_objectSpread({}, _propTypes.default.grid), _propTypes.default.space);
GridItem.propTypes = _objectSpread(_objectSpread({}, _propTypes.default.grid), _propTypes.default.space);